import { render, staticRenderFns } from "./MuscleDetail.vue?vue&type=template&id=7d6d38de&"
import script from "./MuscleDetail.vue?vue&type=script&lang=js&"
export * from "./MuscleDetail.vue?vue&type=script&lang=js&"
import style0 from "./MuscleDetail.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./MuscleDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports